import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

export function LandingPage() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({ appState: { returnTo: '/auth/callback' } });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isAuthenticated) return <Navigate to="/auth/callback" replace />;
  return null;
}
